const reassignLocation = (path: string, router: any) => {
  // Hack for now since errors were being thrown sometimes for router.push
  // because of localhost vs ce.onehopewine
  if (window && path === 'https://ce.onehopewine.com') {
    return window.location.assign(`${path}`);
  }

  if (window) {
    switch (window.location.pathname) {
      case '/ceo/events':
      case '/ceo/customers':
      case '/ceo/orders':
        router(path);
        break;
      default:
        window.location.assign(`${path}`);
    }
  }
};

export default reassignLocation;
